module.exports = __webpack_public_path__ + "img/GON.4d4deffa.svg";